import {
  PauseCircleFilledOutlined,
  PlayCircleFilledOutlined,
} from "@mui/icons-material";
import { IconButton, IconButtonProps } from "@mui/material";
import TEST_ID from "enums/TEST_ID";
import { useContext } from "react";
import { getDataTestProp } from "utils/cypressTesting";
import TimelinePlayerContext from "../context/TimelinePlayerContext";

export default function PlayPauseButton({ sx, ...rest }: IconButtonProps) {
  const { playing, setPlaying } = useContext(TimelinePlayerContext);

  return playing ? (
    <IconButton
      title="Pause"
      size="medium"
      sx={{
        padding: 0,
        color: (theme) => theme.palette.secondary.dark,
        ...(sx || {}),
      }}
      onClick={() => setPlaying(false)}
      {...getDataTestProp(TEST_ID.player.pause)}
      {...rest}
    >
      <PauseCircleFilledOutlined />
    </IconButton>
  ) : (
    <IconButton
      title="Play"
      size="medium"
      sx={{ p: 0, color: (theme) => theme.palette.secondary.dark, ...sx }}
      onClick={() => setPlaying(true)}
      {...getDataTestProp(TEST_ID.player.play)}
      {...rest}
    >
      <PlayCircleFilledOutlined />
    </IconButton>
  );
}
